import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private submenuVisibleSubject = new BehaviorSubject<boolean>(false);
   public submenuVisible$: Observable<boolean> = this.submenuVisibleSubject.asObservable();
  private currentRouteSubject = new BehaviorSubject<string>('');
  public currentRoute$: Observable<string> = this.currentRouteSubject.asObservable();
  private currentRouteDataSubject = new BehaviorSubject<any>({});
  public currentRouteData$: Observable<any> = this.currentRouteDataSubject.asObservable();
  constructor() { }

  toggleSubmenu(visible: boolean): void {
    this.submenuVisibleSubject.next(visible);
  }

  isSubmenuVisible(): boolean {
    return this.submenuVisibleSubject.value;
  }  

  setCurrentRouteData(data: any): void {
    this.currentRouteDataSubject.next(data);
  }
  getCurrentRouteData(): Observable<any> {
    return this.currentRouteDataSubject.asObservable();
  }
} 